import { FC, memo } from 'react';
import { RightOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ClinicSettingsItem } from '../../../models/Settings/ClinicSettings';
import { ClinicSettingsRequest } from '../../../store/reducers/ClinicSettingsSlice';
import { TableFooter } from '../../TableFooter';
import { TableResults } from '../../shared/TableResults';
import styles from './styles.module.css';

interface Props {
  items: ClinicSettingsItem[];
  totalItemsCount: number;
  callRequest: ClinicSettingsRequest;
  pageSize: number;
  onChange: (page: number) => void;
  handlePageSizeChange: (value: string) => void;
  loading?: boolean;
  hasLoadError?: boolean;
}

export const ClinicSettingsTable: FC<Props> = memo(
  ({
    items,
    totalItemsCount,
    callRequest,
    pageSize,
    onChange,
    handlePageSizeChange,
    loading = false,
    hasLoadError = false,
  }: Props) => {
    const navigate = useNavigate();

    return (
      <div className={styles.clinicSettingsTable}>
        <TableResults
          isEmpty={items.length === 0 && totalItemsCount === 0 && !hasLoadError}
          loading={loading}
        >
          <div className={styles.listScroll}>
            {items.map((item) => {
              const phone =
                item.operatorPhone && item.operatorPhone !== '0'
                  ? item.operatorPhone
                  : 'Номер оператора не указан';
              const sip = item.sipAccount?.server ?? '—';
              const subtitle = `${phone}   ·   ${sip}`;

              const navState = {
                search: callRequest.ClinicNameSearch,
                pageIndex: callRequest.PageIndex,
                pageSize,
              };

              return (
                <div
                  key={item.id}
                  className={styles.clinicCard}
                  aria-disabled={loading}
                  onClick={() =>
                    loading
                      ? undefined
                      : navigate(`/settings/calls/${item.clinic?.id}`, {
                          state: navState,
                        })
                  }
                >
                  <span className={styles.clinicIconWrap}>
                    <MedicineBoxOutlined className={styles.clinicIcon} />
                  </span>

                  <div className={styles.clinicInfo}>
                    <span className={styles.clinicName}>
                      {item.clinic?.name ?? '—'}
                    </span>
                    <span className={styles.clinicMeta}>{subtitle}</span>
                  </div>

                  <span className={styles.arrowIcon}>
                    <RightOutlined />
                  </span>
                </div>
              );
            })}
          </div>

          <TableFooter
            pageIndex={callRequest.PageIndex}
            pageSize={pageSize}
            total={totalItemsCount}
            onPageChange={onChange}
            onPageSizeChange={handlePageSizeChange}
            disabled={loading}
          />
        </TableResults>
      </div>
    );
  },
);

ClinicSettingsTable.displayName = 'ClinicSettingsTable';
